/**
 * PseudoTabs component is a styled tab-like component that displays a title.
 * It does not have any interactive functionality like switching tabs.
 * It is used for display purposes only.
 */
export const PseudoTabs = ({ title }: { title: string }) => {
  return (
    <div className="border-b border-alpha-100">
      <h2 className="text-sm font-medium text-content-1000 pb-2 border-b-2 border-content-1000 inline-block translate-y-px">
        {title}
      </h2>
    </div>
  );
};
